import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'
import { createGiftUrl } from 'components/storefront/StoreFrontGifts/StoreFrontGifts.functions'
import { findGiftFormat } from 'functions/findGiftFormat'
import {
  GQLGiftImageFormatType,
  GQLMyGiftImage,
} from 'generated-graphql/graphql'

export const createGiftUrlFromFormats = (
  image?: GQLMyGiftImage,
  giftFormats?: GQLGiftImageFormatType[]
) => {
  if (image && image.formats && giftFormats) {
    const { name, formats } = image
    const { svg, png } = findGiftFormat(giftFormats)
    return createGiftUrl(formats.indexOf(7) > -1 ? svg : png, name)
  }
}

export const createGiftUrlForForeignProfile = (
  name: string,
  currentGiftSupportFormats: number[],
  giftsCommonFormat: GQLForeignRootQuery['ui']['giftFormats']
) => {
  const format = giftsCommonFormat.find(
    ({ formatId }) =>
      formatId ===
      currentGiftSupportFormats[currentGiftSupportFormats.length - 1]
  )

  return createGiftUrl(format!, name)
}
